// Component icons
import bainmaries from "../../assets/img/icons/bainmaries.png";
import blenders from "../../assets/img/icons/blenders.png";
import boiler from "../../assets/img/icons/boiler.png";
import burner from "../../assets/img/icons/burner.png";
import kitchenMachineries from "../../assets/img/icons/kitchen-machineries.png";
import sink from "../../assets/img/icons/sink.png";
import table from "../../assets/img/icons/table.png";
import trolley from "../../assets/img/icons/trolley.png";
import kitchenEquipment from "../../assets/img/icons/kitchen_equipment.png";
import ladder from "../../assets/img/icons/ladder.png";
// Component product images

// Kitchen Machineries images
import vegetableCutter from "../../assets/img/kitchen-equipments/kitchen-machineries/vegetable-cutter.jpg";
import attaKneader from "../../assets/img/kitchen-equipments/kitchen-machineries/atta-kneader.jpg";
import tiltingGrinder from "../../assets/img/kitchen-equipments/kitchen-machineries/Tilting-Grinder.jpg";
import doughKneader from "../../assets/img/kitchen-equipments/kitchen-machineries/dough-kneader.jpg";
import deepFatFryer from "../../assets/img/kitchen-equipments/kitchen-machineries/deep-fat-fryer.jpg";
// Kitchen Machineries images

// Ribbon blenders images
import ribbonBlenderMixer from "../../assets/img/kitchen-equipments/ribbon-blenders/Ribbon-Blender-Mixer.jpg";
import detergentMixingMachine from "../../assets/img/kitchen-equipments/ribbon-blenders/detergent-mixing-machine.jpg";
import ribbonBlenderAgarbathi from "../../assets/img/kitchen-equipments/ribbon-blenders/Ribbon-Blender-Agarbathi.jpg";
import industrialRibbonBlenderMachine from "../../assets/img/kitchen-equipments/ribbon-blenders/Industrial-Ribbon-Blender-Mixer.jpg";
// Ribbon blenders images

// Steam Equipments images
import boiler1 from "../../assets/img/kitchen-equipments/steam-equipments/boiler32.jpg";
import boiler2 from "../../assets/img/kitchen-equipments/steam-equipments/boiler920.jpg";
import bakeryShowcase from "../../assets/img/kitchen-equipments/steam-equipments/bakery-showcase.jpg";
import riceVesselsWithBurner from "../../assets/img/kitchen-equipments/steam-equipments/Rice-Vessels-With-Burner.jpg";
// Steam Equipments images

// Gas Ranges images
import barbeque from "../../assets/img/kitchen-equipments/gas-ranges/barbeque.jpg";
import chickenGrillMachine from "../../assets/img/kitchen-equipments/gas-ranges/Chicken-Grill-Machine.jpg";
import chineseTriple from "../../assets/img/kitchen-equipments/gas-ranges/chinese-triple.jpg";
import dosaPlate from "../../assets/img/kitchen-equipments/gas-ranges/Dosa-Plate-1.jpg";
import singleBurnerRange from "../../assets/img/kitchen-equipments/gas-ranges/single-burner-range.jpg";
// Gas Ranges images

// Bainmaries images
import commercialBainmarie from "../../assets/img/kitchen-equipments/bainmaries/Commercial-Bain-Marie.jpg";
import showcaseBainmari from "../../assets/img/kitchen-equipments/bainmaries/showcase-bainmari.jpeg";
import tantooripot from "../../assets/img/kitchen-equipments/bainmaries/Tantoori-pot.jpg";
import bainmari5 from "../../assets/img/kitchen-equipments/bainmaries/bainmari5.jpeg";
import bainmari10 from "../../assets/img/kitchen-equipments/bainmaries/bainmarie10.jpeg";
import bainmari11 from "../../assets/img/kitchen-equipments/bainmaries/bainmarie11.jpeg";
import bainmari4 from "../../assets/img/kitchen-equipments/bainmaries/bainmarie-four.jpeg";
import bainmariRound from "../../assets/img/kitchen-equipments/bainmaries/bainmarie-round.jpeg";
import bainmariSquare from "../../assets/img/kitchen-equipments/bainmaries/bainmarie-square.jpeg";
// Bainmaries images

// Trolleys images
import trackRack from "../../assets/img/kitchen-equipments/trolleys/tray-rack-trolley.jpg";
import serviceTrolley from "../../assets/img/kitchen-equipments/trolleys/service-trolley.jpg";
import storageTrolley from "../../assets/img/kitchen-equipments/trolleys/storage-trolley.jpg";
import platformTrolley from "../../assets/img/kitchen-equipments/trolleys/platform-trolley.jpg";
import ssTrolley from "../../assets/img/kitchen-equipments/trolleys/Stainless-Steel-Trolley.jpg";
import industrialTrolley from "../../assets/img/kitchen-equipments/trolleys/Industrial-Trolley.jpg";
import plateCollectionTrolley from "../../assets/img/kitchen-equipments/trolleys/plate-collection-trolley.jpg";
import masalaTrolley from "../../assets/img/kitchen-equipments/trolleys/Masala-Trolley.jpg";
// Trolleys images

// Counters images
// Counters images

// Tables images
import ssDiningTable from "../../assets/img/kitchen-equipments/tables/ss-dining-table.jpg";
import ssDiningTable0 from "../../assets/img/kitchen-equipments/tables/dining-table.jpg";
import ssDiningTable1 from "../../assets/img/kitchen-equipments/tables/dinning-table1.jpeg";
import ssDiningTableFold from "../../assets/img/kitchen-equipments/tables/folding-dining-table.jpg";
import foldingTable from "../../assets/img/kitchen-equipments/tables/folding-table.jpeg";
import graniteDiningTable from "../../assets/img/kitchen-equipments/tables/GRANITE-DINING-TABLE.jpg";
import roundTableTop from "../../assets/img/kitchen-equipments/tables/round-table-topview.jpeg";
import roundTableBottom from "../../assets/img/kitchen-equipments/tables/round-table-folded-view.jpeg";
import ssChair from "../../assets/img/kitchen-equipments/tables/Stainless-Steel-Chair.jpg";
import table8seated from "../../assets/img/kitchen-equipments/tables/table-8seated.jpeg";
// Tables images

// Sinks images
import plateWashSink from "../../assets/img/kitchen-equipments/sinks/Plate-Wash-Sink.jpg";
import tripleBowlSink from "../../assets/img/kitchen-equipments/sinks/triple-bowl-sink.jpg";
import footpressSingleBowlSink from "../../assets/img/kitchen-equipments/sinks/foot-press-Single-Bowl-Sink.jpg";
import WorkingTableWithSink from "../../assets/img/kitchen-equipments/sinks/Working-Table-with-Sink.jpg";
// Sinks images

// Staircase Item images
import staircase1 from "../../assets/img/kitchen-equipments/staircase/1.jpg";
import staircase2 from "../../assets/img/kitchen-equipments/staircase/2.jpg";
import staircase3 from "../../assets/img/kitchen-equipments/staircase/3.jpg";
import staircase4 from "../../assets/img/kitchen-equipments/staircase/4.jpg";
import staircase5 from "../../assets/img/kitchen-equipments/staircase/5.jpg";
import staircase6 from "../../assets/img/kitchen-equipments/staircase/6.jpg";
// Staircase Item images

// Other Item images
import hotcase3 from "../../assets/img/kitchen-equipments/others/3-container-hotcase.jpg";
import hotcase6 from "../../assets/img/kitchen-equipments/others/6-container-hotcase.jpg";
import blower from "../../assets/img/kitchen-equipments/others/blower.jpg";
import footSanitizer from "../../assets/img/kitchen-equipments/others/foot-sanitizer-perusing-ms-stand.jpg";
import onionBin from "../../assets/img/kitchen-equipments/others/Onion-Bin.jpg";
// Other Item images

const kitchenMachineriesItems = [
  {
    label: "Vegetable Cutter",
    imgURL: vegetableCutter,
  },
  {
    label: "Atta Kneader",
    imgURL: attaKneader,
  },
  {
    label: "Tilting Grinder",
    imgURL: tiltingGrinder,
  },
  {
    label: "Dough Kneader",
    imgURL: doughKneader,
  },
  {
    label: "Deep Fat Fryer",
    imgURL: deepFatFryer,
  },
];

const blendersItems = [
  {
    label: "500kg Ribbon Blender Mixer",
    imgURL: ribbonBlenderMixer,
  },
  {
    label: "Dry Detergent Mixing Machine",
    imgURL: detergentMixingMachine,
  },
  {
    label: "Ribbon Blender Agarbathi",
    imgURL: ribbonBlenderAgarbathi,
  },
  {
    label: "Industrial Ribbon Blender Machine",
    imgURL: industrialRibbonBlenderMachine,
  },
];

const steamEquipmentsItems = [
  {
    label: "Steam Boiler",
    imgURL: boiler1,
  },
  {
    label: "Steam Boiler",
    imgURL: boiler2,
  },
  {
    label: "Steam Cooking Boiler Unit",
    imgURL: bakeryShowcase,
  },
  {
    label: "Rice Vessel",
    imgURL: riceVesselsWithBurner,
  },
];

const gasRangesItems = [
  {
    label: "Single Burner Range",
    imgURL: singleBurnerRange,
  },
  {
    label: "Chinese Triple",
    imgURL: chineseTriple,
  },
  {
    label: "Dosa Plate",
    imgURL: dosaPlate,
  },
  {
    label: "Barbeque Griller",
    imgURL: barbeque,
  },
  {
    label: "Chicken Griller",
    imgURL: chickenGrillMachine,
  },
];

const bainmariesItems = [
  {
    label: "Commercial BainMarie",
    imgURL: commercialBainmarie,
  },
  {
    label: "Showcase Bainmarie",
    imgURL: showcaseBainmari,
  },
  {
    label: "Tantoori Pot",
    imgURL: tantooripot,
  },
  {
    label: "Bainmarie 4 Pot",
    imgURL: bainmari4,
  },
  {
    label: "Bainmarie 5 Pot",
    imgURL: bainmariSquare,
  },
  {
    label: "Bainmarie 5 Pot Closed",
    imgURL: bainmari5,
  },
  {
    label: "Bainmarie Six Pot",
    imgURL: bainmariRound,
  },
  {
    label: "Bainmarie 10 Pot",
    imgURL: bainmari10,
  },
  {
    label: "Bainmarie 11 Pot",
    imgURL: bainmari11,
  },
];

const trolleysItems = [
  {
    label: "Tray Rack Trolley",
    imgURL: trackRack,
  },
  {
    label: "Service Trolley",
    imgURL: serviceTrolley,
  },
  {
    label: "Storage Trolley",
    imgURL: storageTrolley,
  },
  {
    label: "Platform Trolley",
    imgURL: platformTrolley,
  },
  {
    label: "Commercial Trolley",
    imgURL: ssTrolley,
  },
  {
    label: "Industrial Trolley",
    imgURL: industrialTrolley,
  },
  {
    label: "Plate Collection Trolley",
    imgURL: plateCollectionTrolley,
  },
  {
    label: "Masala Trolley",
    imgURL: masalaTrolley,
  },
];

// const countersItems = [];

const tablesItems = [
  {
    label: "6 Seated Dining Table",
    imgURL: ssDiningTable,
  },
  // {
  //   label: "Engineering",
  //   imgURL: ssDiningTable0,
  // },
  // {
  //   label: "Engineering",
  //   imgURL: ssDiningTable1,
  // },
  // {
  //   label: "Engineering",
  //   imgURL: ssDiningTableFold,
  // },
  {
    label: "Folding Table",
    imgURL: foldingTable,
  },
  {
    label: "Granite Dining Table",
    imgURL: graniteDiningTable,
  },
  {
    label: "Round Table Top",
    imgURL: roundTableTop,
  },
  {
    label: "Round Table Bottom",
    imgURL: roundTableBottom,
  },
  {
    label: "Steel Chair",
    imgURL: ssChair,
  },
  {
    label: "8 Seated Dining Table",
    imgURL: table8seated,
  },
];

const sinksItems = [
  {
    label: "Plate Wash Sink",
    imgURL: plateWashSink,
  },
  {
    label: "Triple Bowl Sink",
    imgURL: tripleBowlSink,
  },
  {
    label: "Foot press Single Bowl Sink",
    imgURL: footpressSingleBowlSink,
  },
  {
    label: "Working Table With Sink",
    imgURL: WorkingTableWithSink,
  },
];

const staircaseItems = [
  {
    label: "Staircase",
    imgURL: staircase1,
  },
  {
    label: "Staircase",
    imgURL: staircase2,
  },
  {
    label: "Staircase",
    imgURL: staircase3,
  },
  {
    label: "Staircase",
    imgURL: staircase4,
  },
  {
    label: "Staircase",
    imgURL: staircase5,
  },
  {
    label: "Staircase",
    imgURL: staircase6,
  },
];

const otherItems = [
  {
    label: "3 Container Hotcase",
    imgURL: hotcase3,
  },
  {
    label: "6 Container Hotcase",
    imgURL: hotcase6,
  },
  {
    label: "Blower",
    imgURL: blower,
  },
  {
    label: "Onion Bin",
    imgURL: onionBin,
  },
  {
    label: "Foot Sanitizer Perusing MS Stand",
    imgURL: footSanitizer,
  },
];

export const OurProductsRangeList = [
  {
    label: "Kitchen Machineries",
    imgURL: kitchenMachineries,
    productItems: kitchenMachineriesItems,
  },
  {
    label: "Ribbon blenders",
    imgURL: blenders,
    productItems: blendersItems,
  },
  {
    label: "Steam Equipments",
    imgURL: boiler,
    productItems: steamEquipmentsItems,
  },
  {
    label: "Gas Ranges",
    imgURL: burner,
    productItems: gasRangesItems,
  },
  {
    label: "Bainmaries",
    imgURL: bainmaries,
    productItems: bainmariesItems,
  },
  {
    label: "Trolleys",
    imgURL: trolley,
    productItems: trolleysItems,
  },
  // {
  //   label: "Counters",
  //   imgURL: kitchenEquipment,
  //   productItems: countersItems,
  // },
  {
    label: "Tables",
    imgURL: table,
    productItems: tablesItems,
  },
  {
    label: "Sinks",
    imgURL: sink,
    productItems: sinksItems,
  },
  {
    label: "Staircase",
    imgURL: ladder,
    productItems: staircaseItems,
  },
  {
    label: "Other Items",
    imgURL: kitchenEquipment,
    productItems: otherItems,
  },
];
